// 单点登录核心类
import { getUrlParam } from '/@/utils';
import { useGlobSetting } from '/@/hooks/setting';
import { useUserStore } from '/@/store/modules/user';
import { userManager } from '../setting/userManager';
import { logManager } from '../setting/useLogManager';
import { CookieStorage } from '@do/do-auth-web-client';
import { message } from 'ant-design-vue';
const globSetting = useGlobSetting();
const openSso = globSetting.openSso;
export function useSso() {
  const locationUrl = 'http://' + window.location.host + '/';
  /**
   * 单点登录
   */
  async function ssoLogin() {
    if (openSso == 'true') {
      return new Promise(async (r, j) => {
        console.log('----------开始designorder的登录流程------------');
        try {
          userManager.registerOnLoginCallback(async (user) => {
            const userStore = useUserStore();
            userStore.setToken(user.token);
            const loginResult = await userStore.afterLoginAction(false, {});
            logManager.setUser(user.user.id);
            r(loginResult);
          });
          userManager.registeronLogoutCallback(() => {
            userManager.redirectToLogin();
          });
  
          if (!(await userManager.checkLogin())) {
            if (!getUrlParam('token')) {
              userManager.redirectToLogin();
               // 新手引导localStorage存储规则：规定账号登出后会removeitem
              localStorage.removeItem('community.tour.guide');
              j('尚未登录');
            }
          }
        } catch (error) {
         
        } finally{
          //丑陋的补丁
          const cookie_storage = new CookieStorage();
          const user = cookie_storage.getUserInfo();
          if (!user) {
            message.error('token有误请检查！');
          }
        }
  
      });

      // const token = getToken();
      // const ticket = getUrlParam('ticket');
      // if (!token) {
      //     if (ticket) {
      //         await validateCasLogin({
      //             ticket: ticket,
      //             service: locationUrl,
      //         }).then((res) => {
      //             const userStore = useUserStore();
      //             userStore.setToken(res.token);
      //             return userStore.afterLoginAction(true, {});
      //         });
      //     } else {
      //         window.location.href =
      //             globSetting.casBaseUrl +
      //             '/login?service=' +
      //             encodeURIComponent(locationUrl);
      //     }
      // }
    }
  }

  /**
   * 退出登录
   */
  async function ssoLoginOut() {
    userManager.logout();
    // window.location.href =
    //     globSetting.casBaseUrl + '/logout?service=' + encodeURIComponent(locationUrl);
  }
  return { ssoLogin, ssoLoginOut };
}
